import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as utils from "../Utils/comman";

export const fetchTravelExpenses = createAsyncThunk(
  "expenses/fetchTravelExpenses",
  async ({ page, countPerPage, from_date, to_date, sr_status, hr_status }, thunkAPI) => {
    try {
      // Build query parameters with filters
      let query = `expense/list?page=${page}&per_page=${countPerPage}`;

      if (from_date) query += `&from_date=${from_date}`;
      if (to_date) query += `&to_date=${to_date}`;
      if (sr_status) query += `&sr_status=${sr_status}`;
      if (hr_status) query += `&hr_status=${hr_status}`;

      const response = await utils.callAPI("get", query);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  expenses: [],
  isLoading: false,
  isError: false,
  errorMessage: "",
};

const travelExpensesSlice = createSlice({
  name: "expenses",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTravelExpenses.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(fetchTravelExpenses.fulfilled, (state, action) => {
        state.expenses = action.payload;
        state.isLoading = false;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(fetchTravelExpenses.rejected, (state, action) => {
        state.expenses = [];
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      });
  },
});

export default travelExpensesSlice.reducer;
